// extracted by mini-css-extract-plugin
export default {"wrapper":"Y0-z","play":"Z0-z"};